import { Component, Input, OnInit } from '@angular/core';
import { ActionPriority, IncidentHighPotential } from 'src/app/performance-dashboard/model/performance.model';
import { Router } from '@angular/router';
import { PerformanceService } from '../../../services/performance.service';
import { ConstantsService } from '../../../../shared/services/constants.service';
import * as XLSX from 'xlsx';

@Component({
  selector: 'ara-incident-high-potential',
  templateUrl: './incident-high-potential.component.html',
  styleUrls: ['./incident-high-potential.component.css']
})
export class IncidentHighPotentialComponent implements OnInit {
  @Input() IncidentHighPotentialData;
  @Input() selectedUnit: any;
  @Input() year: any;
  @Input() MonthRange: any;
  clonedIncidentHighPotentialData: { [s: string]: IncidentHighPotential } = {};
  IncHPData : any;
  DisableExport : boolean = false;

  constructor(private PDService: PerformanceService,private router: Router) { }

  ngOnInit(): void {
  }

  onRowEditInit(incidentHighPotential: IncidentHighPotential) {
    this.clonedIncidentHighPotentialData[incidentHighPotential.Id] = { ...incidentHighPotential };
    this.DisableExport = true;
  }

  onRowEditSave(incidentHighPotential: IncidentHighPotential) {
    if (incidentHighPotential) {
      let newIncidentHighPotentialData = [];
      this.IncidentHighPotentialData.forEach(element => {
        if(element.category !== "Total")
        newIncidentHighPotentialData.push(element);
      });

      this.IncidentHighPotentialData[this.IncidentHighPotentialData.length - 1].Yes = newIncidentHighPotentialData.reduce((acc, cur) => acc + cur.Yes, 0);
      this.IncidentHighPotentialData[this.IncidentHighPotentialData.length - 1].No = newIncidentHighPotentialData.reduce((acc, cur) => acc + cur.No, 0);

      delete this.clonedIncidentHighPotentialData[incidentHighPotential.Id];
      //this.messageService.add({severity:'success', summary: 'Success', detail:'Product is updated'});
    } else {
      //this.messageService.add({severity:'error', summary: 'Error', detail:'Invalid Price'});
    }
    this.DisableExport = Object.keys(this.clonedIncidentHighPotentialData).length > 0 ? true : false;
  }

  onRowEditCancel(incidentHighPotential: IncidentHighPotential, index: number) {
    this.IncidentHighPotentialData[index] = this.clonedIncidentHighPotentialData[incidentHighPotential.Id];
    delete this.clonedIncidentHighPotentialData[incidentHighPotential.Id];
    this.DisableExport = Object.keys(this.clonedIncidentHighPotentialData).length > 0 ? true : false;
  }
  
  GetIncidentHighPotentialSelectedDetails(UnitId,Unit,Column){
  
    const apiRequest = {
      Model: {
        "Units": this.selectedUnit,//this.child1.selectedUnit,
        "Year": this.year,//this.child1.year,
        "Months":this.MonthRange,//this.child1.MonthRange,
        "ModuleName":"Incident High Potential",
        "Component":Unit === "Total" ? 0 : UnitId,
        "Column":Column,
        "ComponentName":Unit
     }
    };

    this.PDService.getPDSelectedDetails(apiRequest,this.callbackMethodForGetIncidentHighPotentialSelectedDetails.bind(this));
  }
  callbackMethodForGetIncidentHighPotentialSelectedDetails(response){
    if(response.Success)
    this.IncHPData = response.Result;
  }

  Redirect(value,UnitId)
  {
  //this.router.navigate(['/incident/report-incident/'+value])
  window.open(ConstantsService.URL.APP + ['/incident/report-incident/'+value], '_self');
  }

  //BOC Pritesh
  exportToExcel()
  {

  let element = document.getElementById('IncidentHighPotentialTableToExport');
  const ws: XLSX.WorkSheet =XLSX.utils.table_to_sheet(element);
 
  ws['!ref'] = ws['!ref'].replace('D','C');//to remove Actions Column
  /* generate workbook and add the worksheet */
  const wb: XLSX.WorkBook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');

  /* save to file */  
  XLSX.writeFile(wb, "IncidentHighPotential.xlsx");

  }
  //EOC Pritesh

}
